// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-payment-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  background-color: var(--color-button-text);
  cursor: auto;
}
.checkout-payment-wrapper .divider {
  border-color: #dce2f0;
  margin: var(--spacing-small) 0;
}
.checkout-payment-wrapper .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 24px;
  cursor: auto;
}
.checkout-payment-wrapper .vert-paragraph span {
  font-weight: 400;
}
.checkout-payment-wrapper .vert-paragraph span:before {
  content: ' ';
}
.checkout-payment-wrapper .checkout-payment-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin-bottom: var(--spacing-small);
}
.checkout-payment-wrapper .checkout-payment-title .vert-icon {
  cursor: auto;
}
.checkout-payment-wrapper .checkout-payment-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.checkout-payment-wrapper .checkout-payment-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.checkout-payment-wrapper .checkout-payment-content .vert-row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.checkout-payment-wrapper .checkout-payment-content .vert-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.checkout-payment-wrapper .checkout-payment-content .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 24px;
  cursor: auto;
}
.checkout-payment-wrapper .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-payment-wrapper .checkout-payment-value {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.checkout-payment-wrapper .ant-radio-inner {
  border-color: var(--color-detached) !important;
}
.checkout-payment-wrapper .ant-radio-inner::after {
  background-color: var(--color-detached) !important;
  transform: scale(0.7);
  opacity: 1;
  border-radius: 50% !important;
}
@media screen and (max-width: 768px) {
  .checkout-payment-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutPaymentStyles.less"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AAAF;AALA;EAOI,qBAAA;EACA,8BAAA;AACJ;AATA;EAYI,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAAJ;AAfA;EAiBM,gBAAA;AACN;AAAM;EACE,YAAA;AAER;AArBA;EAyBI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AADJ;AA3BA;EA+BM,YAAA;AADN;AA9BA;EAiCQ,WAAA;EACA,YAAA;EACA,sCAAA;AAAR;AAnCA;EAyCI,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;AAxCA;EA8CM,0BAAA;EACA,yBAAA;AAHN;AA5CA;EAkDM,0BAAA;EACA,2BAAA;AAHN;AAhDA;EAsDM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAHN;AAtDA;EA8DI,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AALJ;AA9DA;EAuEI,aAAA;EACA,sBAAA;EACA,yBAAA;AANJ;AAnEA;EA6EI,8CAAA;AAPJ;AASI;EACE,kDAAA;EACA,qBAAA;EACA,UAAA;EACA,6BAAA;AAPN;AAaA;EACE;IACE,6BAAA;IACA,0CAAA;EAXF;AACF","sourcesContent":["// DESKTOP\n.checkout-payment-wrapper {\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  background-color: var(--color-button-text);\n  cursor: auto;\n  .divider {\n    border-color: #dce2f0;\n    margin: var(--spacing-small) 0;\n  }\n\n  .vert-paragraph {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    line-height: 24px;\n    cursor: auto;\n    span {\n      font-weight: 400;\n      &:before {\n        content: ' ';\n      }\n    }\n  }\n\n  .checkout-payment-title {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-extra-small);\n    margin-bottom: var(--spacing-small);\n\n    .vert-icon {\n      cursor: auto;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: var(--color-neutral-dark-darker);\n      }\n    }\n  }\n\n  .checkout-payment-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    .vert-row {\n      margin-right: 0 !important;\n      margin-left: 0 !important;\n    }\n    .vert-col {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 24px;\n      cursor: auto;\n    }\n  }\n\n  .vert-title {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    line-height: 24px !important;\n    margin: 0;\n    text-align: left;\n    cursor: auto;\n  }\n\n  .checkout-payment-value {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n  }\n\n  .ant-radio-inner {\n    border-color: var(--color-detached) !important;\n\n    &::after {\n      background-color: var(--color-detached) !important;\n      transform: scale(0.7);\n      opacity: 1;\n      border-radius: 50% !important;\n    }\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-payment-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
